<template>
  <div>
    <h1>Colps</h1>
    <v-switch label="Show archived" v-model="archived" />
    <v-btn @click="createColp()">
      <v-icon>add</v-icon>Colp
    </v-btn>
    <v-data-table
      :headers="headers"
      :items="computedColps"
      :pagination.sync="pagination"
      class="elevation-1"
    >
      <template v-slot:items="props">
        <tr>
          <td>
            <v-btn :to="{name:'colp', params:{id:props.item.id}}" small>{{props.item.id}}</v-btn>
          </td>
          <td>
            <FileZ :file="props.item.file" v-if="props.item.file" />
            <span v-if="!props.item.file">{{props.item.freereference}}</span>
          </td>
          <td>
            <EntityZ :entity="props.item.user" format="system" v-if="props.item.user" />
          </td>
          <td>{{props.item.received | formatDate}}</td>
          <td>
            <v-btn @click="deleteColp(props.item)" color="error" small>
              <v-icon>delete</v-icon>
            </v-btn>
          </td>
        </tr>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import EntityZ from "@/components/link/EntityZ";
import FileZ from "@/components/link/FileZ";
import nbmlaw from "@/api/nbmlaw";
export default {
  name: "Colps",
  metaInfo() {
    return {
      title: "Colps",
      titleTemplate: "%s - Customer care - Conveyancing Tracker",
      htmlAttrs: {
        lang: "en",
        amp: true
      }
    };
  },
  components: { EntityZ, FileZ },
  computed: {
    computedColps() {
      if (!this.colps) {
        return undefined;
      }
      return this.colps.map(c => {
        const file = this.files ? this.files[c.fileid] : undefined;
        const user = this.users ? this.users[c.userid] : undefined;
        return { ...c, file, user };
      });
    }
  },
  data() {
    return {
      archived: false,
      colps: [],
      files: [],
      users: [],
      headers: [
        {
          text: "Id",
          value: "id"
        },
        {
          text: "File",
          value: "file.referencelong"
        },
        {
          text: "Created by",
          value: "user.name"
        },
        {
          text: "Received",
          value: "received"
        },
        {
          text: " ",
          sortable: false
        }
      ],
      pagination: {
        sortBy: "id",
        descending: true,
        page: 1,
        rowsPerPage: -1
      }
    };
  },
  methods: {
    fetchColps() {
      nbmlaw
        .get(`/cors/admin/customerCare/colps`, {
          params: { archived: this.archived }
        })
        .then(response => {
          // console.log(response.data);
          this.colps = response.data;
        });
    },
    fetchFiles() {
      nbmlaw.get(`/cors/admin/customerCare/colps/files`).then(response => {
        // console.log(response.data);
        this.files = response.data;
      });
    },
    fetchUsers() {
      nbmlaw.get(`/cors/admin/customerCare/colps/users`).then(response => {
        // console.log(response.data);
        this.users = response.data;
      });
    },
    createColp() {
      nbmlaw.post(`/cors/admin/customerCare/colps`, null).then(response => {
        // console.log(response.data);
        this.$router.push({ name: "colp", params: { id: response.data } });
      });
    },
    deleteColp(colp) {
      if (confirm("Are you sure?")) {
        nbmlaw.delete(`/cors/admin/customerCare/colps/${colp.id}`).then(() => {
          // console.log(response.data);
          this.update();
        });
      }
    },
    update() {
      this.fetchColps();
      this.fetchFiles();
      this.fetchUsers();
    }
  },
  watch: {
    archived: {
      handler() {
        this.update();
      }
    }
  },
  created() {
    this.update();
  }
};
</script>
